// removed by extract-text-webpack-plugin
module.exports = {"clear":"GenerateDocumentPopup__clear___-_D-3","popupWrapper":"GenerateDocumentPopup__popupWrapper___2NO_7","popupContent":"GenerateDocumentPopup__popupContent___1VppM","selectTemplate":"GenerateDocumentPopup__selectTemplate___3GbKZ","row":"GenerateDocumentPopup__row___Kuki1","selectDocumentType":"GenerateDocumentPopup__selectDocumentType___2PnCf","btnGroup":"GenerateDocumentPopup__btnGroup___2gokp","radioWrap":"GenerateDocumentPopup__radioWrap___2XWY9"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/EditComplaint/DocumentTab/GenerateDocumentPopup/GenerateDocumentPopup.scss
// module id = 740
// module chunks = 0